module.exports = __webpack_public_path__ + "static/media/3.85b0b95f.png";